import { getAuthenticatedRequestInit } from './utils';

export const SaveSettings = (token: string, meeting: number, settings: string) => fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/settings`, {
	method: 'POST',
	body: JSON.stringify({
		meeting,
		settings,
	}),
	...getAuthenticatedRequestInit(token),
}).then((res) => res.ok).catch((error) => {
	console.error(error);
});

export const GetUser = (token: string, email: string) => fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/home/find-user`, {
	method: 'POST',
	body: JSON.stringify({
		email,
	}),
	...getAuthenticatedRequestInit(token),
}).then((res) => {
	if (res.ok) {
		return res.json();
	}
	return null;
}).catch((error) => {
	console.error(error);
});

export const UpdateTutorialVideoCount = (token: string) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/tutorial-video`, {
		method: 'PUT',
		...getAuthenticatedRequestInit(token),
	}).then(res => {
		if (res.ok) {
			return res.json();
		}
	}).catch(error => {
		console.error(error);
	});
};

export const UserExists = (email: string) => fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/user-exists`, {
	method: 'POST',
	body: JSON.stringify({
		email,
	}),
	...getAuthenticatedRequestInit(''),
}).then((res) => {
	if (res.ok) {
		return res.json();
	}
	return null;
}).catch((error) => {
	console.error(error);
});
